export const fonts = {
  intro: '"Intro", sans-serif',
  roboto: '"Roboto", sans-serif',
  arial: '"Arial", sans-serif'
};
